import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba, spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    inline-size: ${spacing(50)};
  `,
  body: css`
    padding-inline: 0;
    overflow-x: hidden;
    overflow-y: auto;
  `,
  overlay: css`
    display: none;
  `,
  centerText: css`
    text-align: center;
  `,
  header: css`
    padding-inline-end: ${spacing(6)};
  `,
  css: css`
    box-shadow: 0 ${spacing(1)} ${spacing(2.5)} ${hex2rgba(cssTheme.default.day.everBlack.hex, 0.12)};
  `,
  title: css`
    margin-block-end: ${spacing(2)};
  `,
  headerControls: css`
    padding-block: ${spacing(2)};
  `,

  selectCityButton: css`
    text-decoration-line: underline;
    text-decoration-thickness: ${spacing(0.25)};
    cursor: pointer;
  `,
  closeButton: css`
    margin-block-start: ${spacing(-1)};
    margin-inline-end: ${spacing(-1)};
  `,
  filtersAmountWrap: css`
    position: relative;
  `,
  filtersAmount: css`
    position: absolute;
    inset: 0 0 auto auto;
    inline-size: ${spacing(2)};
    block-size: ${spacing(2)};
    font-size: 11px; // TODO: fix with Typography
    background-color: ${cssTheme.colors.red.normal};
    color: ${cssTheme.default.day.background};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    box-shadow: 0 2px 5px rgba(212, 65, 46, 0.3);
  `,
  emptyText: css`
    margin-inline: ${spacing(9)};
    text-align: center;
  `,
  itemList: css`
    background-color: #f5f4f2; // Theme/Default/Day/CardDivider
  `,
  item: css`
    background-color: ${cssTheme.default.day.background};
    border-radius: ${spacing(4)};
    padding: ${spacing(1.5, 2)};
    margin-block: ${spacing(0.25)};

    &:first-of-type {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      margin-block-start: 0;
    }

    &:last-of-type {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      margin-block-end: 0;
    }
  `,
}
